/**
 * useTranscriptionAudio Hook
 *
 * Custom hook to extract audio player logic from TranscriptionSection component
 * Reduces component complexity and improves maintainability.
 */

import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { useMemo } from 'react';

export function useTranscriptionAudio(selectedItem: GraphQLAuditItem | null) {
  // Audio player logic - similar to AuditItemContent
  const { audioUrl, shouldShowAudioPlayer } = useMemo(() => {
    const audioFileUrl = selectedItem?.contentSnapshot?.audioFileUrl;
    const contentType = selectedItem?.contentSnapshot?.contentType?.toLowerCase();

    return {
      audioUrl: audioFileUrl,
      shouldShowAudioPlayer: audioFileUrl && contentType === 'audio',
    };
  }, [selectedItem?.contentSnapshot?.audioFileUrl, selectedItem?.contentSnapshot?.contentType]);

  return {
    audioUrl,
    shouldShowAudioPlayer,
  };
}
